export default __webpack_public_path__ + "static/man-in-glass-57b5dcf504a0a80954900f190e6cdd1f.png";